import React from 'react';
import WallpaperRounded from '@material-ui/icons/WallpaperRounded';
import ButtonBase from '@material-ui/core/ButtonBase';

import Component from '../../../../../ui-components/Component';
import styles from './styles';
import { isEmptyString, isEmptyList, path, merge } from '../../../../../utils';
import { withTranslations, withResizer } from '../../../../../HoCs';
import pages,{ getRouteForPage } from '../../../../../PageEnums';
import { Link } from 'react-router-dom';
import {reasonMap} from '../../../../../config/translationCofing';

const stagesMap = {
    property_information: 'property_information',
    locked_state:'locked',
    in_progress_state:'in_progress',
    property_onboarded_state:'on_boarded',
    commercial_details: 'commercial_details',
    contract_signing: 'contract_signing',
    setup_and_go_live: 'setup_&_go',
    closed:'closed'
};



class OYOCard extends Component {

    styles = styles;
    translation_key = 'properties_translations';

    render = () => {
        const { data = {}, style, className } = this.props;
        return <div style={{ ...this.gs('container'), ...style }} className={className}>
            <div style={this.gs('image_container')}>
                {!isEmptyString(data.image) ?
                    <img src={data.image} alt='Property' style={this.gs('image')} />
                    : <WallpaperRounded style={this.gs('icon')} />
                }
                {/*<AddPhotoAlternateRounded style={{ ...this.gs('change_image'), color: isEmptyString(data.image) ? '#0007' : '#fff8' }} />*/}
            </div>
            <div style={{ padding: 16 }}>
                <div style={this.gs('name')}>{data.name}</div>
                <div style={this.gs('status_label')}>{this.gc('current_status')}</div>
                <div style={this.gs('status_value')}>{isEmptyList(data.status) ? this.gc('not_available'): data.status.map(key => this.gc(stagesMap[key])).join(', ')}</div>
                {this.isActive() && <Link
                    to={getRouteForPage(pages.PROPERTIES,path(this.props.data, 'property_unique_id'))}
                    style={this.gs('view_btn_link')}>
                    <ButtonBase style={this.gs('view_button')}>{this.gc('view_details')}</ButtonBase>
                </Link>}
                {!this.isActive() && <>
                    <div style={this.gs('status_label')}>Closing Reason</div>
                    <div style={this.gs('status_value')}>{this.getClosingReason()}</div>
                </>}
            </div>
        </div>;
    };
    
    isActive = () => !['Closed - Invalid','Closed - Lost'].includes(path(this.props.data,'lead_data.sub_status'));
    
    getClosingReason = () => {
            let reasonKey = path(this.props.data,'lead_data.status_reason_code');
            let reason = reasonMap[reasonKey] || reasonKey;
            if(isEmptyString(reason))reason='Lead was closed';
            return reason;
    };

}


export default withTranslations(withResizer(OYOCard));

